import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { H6, P, UL, LI, Image, H3 } from "../../../../AbstractElements";
import { baseUrl, mediaUrl } from "../../../../Utils/FileUpload";
import { TopAgentTitle } from "../../../../Utils/Constants";
import DashboardSvgIcon from "../../../../Utils/CommonComponents/DashboardSvgIcon";

interface AgentType {
  id: number;
  agent_name: string;
  phone: string;
  email: string;
  address: string;
  image: string;
  is_active: number;
  monthly_call_duration: string;
  agent_monthly_amount: string;
  currency: string;
}

export default function TopUsers({ colClass }: { colClass?: string }) {
  const [agents, setAgents] = useState<AgentType[]>([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6); // default for xxl

  const updateVisibleCount = () => {
    const width = window.innerWidth;

    if (width >= 1400) setVisibleCount(6); // xxl
    else setVisibleCount(5); // sm
  };

  useEffect(() => {
    updateVisibleCount(); // set on first load
    window.addEventListener("resize", updateVisibleCount);

    const token = localStorage.getItem("token");
    axios
      .get(`${baseUrl}agent/top_agent`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setAgents(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching agent data:", error);
      })
      .finally(() => setLoading(false));

    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const currentMonth = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <Col className={colClass || "col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-12"}>
      <Card>
        <CardHeader className="pb-0 card-no-border">
          <div className="header-top">
            {/* <H3>{TopAgentTitle} - <span className="f-14 text-muted">{currentMonth}</span></H3> */}
            <H3>Monthly Top Agent</H3>
          </div>
        </CardHeader>
        <CardBody className="top-user pt-2">
          <UL className="simple-list">
            {loading
              ? Array(visibleCount)
                  .fill(0)
                  .map((_, index) => (
                    <LI
                      key={index}
                      className="d-flex align-items-center justify-content-between gap-2 mb-3"
                    >
                      <div className="d-flex gap-4">
                        <div className="flex-shrink-0 comman-round">
                          <Skeleton circle width={50} height={50} />
                        </div>
                        <div>
                          <Skeleton width={100} height={18} />
                          <Skeleton width={80} height={12} className="mt-1" />
                        </div>
                      </div>
                      <Skeleton width={80} height={14} />
                    </LI>
                  ))
              : agents.slice(0, visibleCount).map((item) => (
                  <LI
                    key={item.id}
                    className="d-flex align-items-center justify-content-between gap-2 mb-2"
                    style={
                      window.innerWidth >= 1400
                        ? { margin: "4px" }
                        : { padding: "6px" }
                    }
                  >
                    <div className="d-flex gap-2">
                      <div className="flex-shrink-0 comman-round">
                        <Image
                          src={`${mediaUrl}/${item.image}`}
                          alt=""
                          className="img-50 me-2 rounded-circle"
                        />
                      </div>
                      <div>
                        <H6>{item.agent_name}</H6>
                        {/* <P>
                          <DashboardSvgIcon iconId="map-icon" />
                          {item.address?.split("\r\n").slice(-1)[0] || "N/A"}
                        </P> */}
                        <p>
                          <strong>Duration:</strong>{" "}
                          {item.monthly_call_duration}
                        </p>
                      </div>
                    </div>
                    <span>{item.currency}{" "}{item.agent_monthly_amount}</span>
                  </LI>
                ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
}

// import React from 'react'
// import { Card, CardBody, Col } from 'reactstrap'
// import DropdownWithHeader from '../../../../Utils/CommonComponents/DropdownWithHeader'
// import { Href, TopUsersTitle } from '../../../../Utils/Constants'
// import { monthlyDropdownList, topUsersData } from '../../../../Data/Dashboard/Default'
// import { Btn, H6, Image, LI, P, UL } from '../../../../AbstractElements'
// import { dynamicImage } from '../../../../Utils'
// import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon'

// export default function TopUsers() {
//     return (
//         <Col xxl={3} xl={5} md={6} className="proorder-xxl-4 box-col-6">
//             <Card>
//                 <DropdownWithHeader end headerClass='pb-0 card-no-border' heading={TopUsersTitle} dropDownList={monthlyDropdownList} dropDownClass='icon-dropdown' dropDownIcon />
//                 <CardBody className="top-user pt-2">
//                     <UL className='simple-list'>
//                         {topUsersData.map((item) => (
//                             <LI key={item.id} className="d-flex align-items-center justify-content-between gap-2">
//                                 <div className="d-flex gap-2">
//                                     <div className="flex-shrink-0 comman-round">
//                                         <Image src={dynamicImage(`dashboard-1/user/${item.image}`)} alt="" />
//                                     </div>
//                                     <div>
//                                         <a href={Href}><H6>{item.name}</H6></a>
//                                         <P>
//                                             <DashboardSvgIcon className="stroke-icon" iconId='map-icon' />
//                                             {'Texas'}
//                                         </P>
//                                     </div>
//                                 </div>
//                                 <Btn color='transparent' className={`bg-light-${item.color} border-light-${item.color} text-${item.color}`}>
//                                     {item.status}
//                                 </Btn>
//                                 <span>{'$'}{item.amount}</span>
//                             </LI>
//                         ))}
//                     </UL>
//                 </CardBody>
//             </Card>
//         </Col>
//     )
// }
